import { render, staticRenderFns } from "./FooterComponentAmseu.vue?vue&type=template&id=7a082988&scoped=true"
import script from "./FooterComponentAmseu.vue?vue&type=script&lang=ts"
export * from "./FooterComponentAmseu.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentAmseu.vue?vue&type=style&index=0&id=7a082988&prod&lang=scss&scoped=true"
import style1 from "./FooterComponentAmseu.vue?vue&type=style&index=1&id=7a082988&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a082988",
  null
  
)

export default component.exports